<div class="skills-container settings-page">

  <div class="settings-page__content">
    <p class="settings-page__description">
      {{ 'SETTINGS_SKILLS.DESCRIPTION' | translate }}
    </p>
    <tf-settings-skills-list />
  </div>
</div>
